"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialValues = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _settingsWrapper = _interopRequireDefault(require("../../../../helpers/settingsWrapper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var initialValues = exports.initialValues = {
  showTitleInTooltip: true,
  mustTakeInOrder: true
};
var Settings = function Settings() {
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    wrapperClassName: "mb-2",
    name: "showTitleInTooltip",
    component: _cccisdFormik.CccisdToggle,
    label: "Show survey title in tooltip"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    wrapperClassName: "",
    name: "mustTakeInOrder",
    component: _cccisdFormik.CccisdToggle,
    label: "User must take surveys in order"
  }));
};
var _default = exports["default"] = (0, _settingsWrapper["default"])({
  initialValues: initialValues
})(Settings);